<template>
	<button class="btn-default" v-on="$listeners" :disabled="disabled" type="button">
		<font-awesome-icon :icon="['fas', 'sync-alt']" class="mr-2" v-if="isLoading" spin />
		<slot />
	</button>
</template>

<script>
export default {
	name: 'BaseButton',
	props: {
		disabled: { default: false },
		isLoading: {},
	},
};
</script>

<style lang="sass" scoped>
.btn-default
	min-width: 140px

.btn-default[disabled]
  transition: 0.3s
  opacity: 0.5
  pointer-events: none
</style>
